import axios from "axios";

const api = axios.create({
  baseURL: "/api", //  41.226.183.241:5501  http://localhost:8080 http://192.168.1.18:8080
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (config.url !== "/auth/login") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
